export const UsersData = `
id
email
username
isActive
permissions
requiredMfa
mfaEnrolledAt
`;
